import(/* webpackMode: "eager" */ "/app/main/app/[locale]/project/js/page.tsx");
